module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAMxJREFUSA3tlDEOg0AMBM8JP+EvUX6SV1HlLVDQpOAPeUYCKWhsCw3SRlDcNejM3t7uGmzfZRW3mv79cqVSbHjcAtL+cDzcvBSs7e7h8hQ4tVcGzJR7xosvZPs0LQ9EBprn+PEHw96Iw7QvgQoWUAqQi3eSEGqVkWCJqh9Gq4x8q4cok9qUkqG/kmaG/l5KJrUpJUPzh9pEc4qSSW1KyaSTlsZBcFKX5EKKqcJoUitOOn5WUsWztnJviqdNTDqu96ayhT9tYlXYVtuydzO7WkPVz9jVMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/Bulgaria.png
// module id = 500
// module chunks = 7